import type { ObservationHeader } from '../types';

interface ObservationTableHeaderProps {
  headerData: ObservationHeader[];
}
const ObservationTableHeader = ({
  headerData,
}: ObservationTableHeaderProps) => {
  return (
    <div className="d-flex flex-row gap-2 height-50">
      <span
        className="font-weight-700 w-25 roboto font-13 text-center d-flex align-items-center"
        style={{ color: '#76746F' }}
      >
        Observation result
      </span>
      <div className="d-flex flex-row w-75 justify-content-evenly align-items-center">
        {headerData.map((item: any, index: number) => (
          <div
            key={`observation-date-${item.id}`}
            className={
              'd-flex w-100 font-weight-700 roboto font-13 text-center border-1 border-bottom h-100 justify-content-center align-items-center' +
              (index === headerData.length - 1 ? '' : ' border-end')
            }
          >
            {item.date}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ObservationTableHeader;
